import { constants } from "../config";

const INITIAL_STATE = {
  user: JSON.parse(localStorage.getItem(constants.userKey)),
  // token: JSON.parse(localStorage.getItem(constants.tokenKey)),
  validToken: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "TOKEN_VALIDATED": {
      if (action.payload) {
        return { ...state, validToken: true };
      } else {
        localStorage.removeItem(constants.userKey);
        localStorage.removeItem(constants.tokenKey);
        return { ...state, validToken: false, user: null };
      }
    }
    case "USER_FETCHED": {
      localStorage.setItem(
        constants.userKey,
        JSON.stringify({
          ...action.payload,
          user: {
            ...action.payload.user,
            profile: action.payload.user.profile || "Administração",
          },
        })
      );
      localStorage.setItem(
        constants.tokenKey,
        JSON.stringify(action.payload.token)
      );
      return {
        ...state,
        user: action.payload,
        token: action.payload.user.token,
        validToken: true,
      };
    }
    case "error": {
      return state;
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/authReducer.js